import { useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Typography, Paper } from '@mui/material';
import { Tabs } from '../../components/shared';
import { TAB_TYPES } from '../../constants/CommonConstants';
import BREADCRUMB_NAMES from '../../constants/breadcrumbNames';
import { routeConstants } from '../../constants/routeConstants';
import { ROUTES } from './constants';
import { OpenTab, ApprovedTab } from './tabs';

const TABS = [
  {
    heading: TAB_TYPES.OPEN_GL_POSTING,
    content: <OpenTab />,
  },
  {
    heading: TAB_TYPES.APPROVED_GL_POSTING,
    content: <ApprovedTab />,
  },
];

const WeeklyGLPosting = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const selectedTab = searchParams.get(ROUTES.TAB_QUERY_PARAM);
  const defaultTab = useMemo(
    () =>
      selectedTab === ROUTES.TAB_QUERY_APPROVED || selectedTab === ROUTES.TAB_QUERY_OPEN
        ? selectedTab
        : ROUTES.TAB_QUERY_OPEN,
    [selectedTab],
  );

  const handleTabChange = (newTabIndex) => {
    const nextTab =
      newTabIndex === ROUTES.TAB_QUERY_APPROVED || newTabIndex === ROUTES.TAB_QUERY_OPEN
        ? newTabIndex
        : ROUTES.TAB_QUERY_OPEN;
    navigate(`/${routeConstants.WEEKLY_GL_POSTING_ROUTE}?${ROUTES.TAB_QUERY_PARAM}=${nextTab}`, {
      replace: true,
    });
  };

  return (
    <>
      <Typography variant="h1">{BREADCRUMB_NAMES.WEEKLY_GL_POSTING.WEEKLY_GL_POSTING}</Typography>

      <Box component={Paper} mt={2}>
        <Tabs tabsData={TABS} defaultTab={defaultTab} onTabChange={handleTabChange} />
      </Box>
    </>
  );
};

export default WeeklyGLPosting;
